import NavigationBar from 'components/gnb/NavigationBar/NavigationBar';
import { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useTableDataStore from 'stores/project/data/useTableDataStore';
import useLayoutStore from 'stores/useLayoutStore';
import useLoadingStore from 'stores/useLoadingStore';
import styled, { css } from 'styled-components';

export interface ToggleSidebarType {
  [key: string]: boolean;
}

const StyledLayout = styled.div<{ $isLoadingOverlay: boolean }>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  background-color: var(--bg-gray-0);
  color: var(--text-gray-strong);

  ${({ $isLoadingOverlay }) =>
    $isLoadingOverlay &&
    css`
      pointer-events: none;
    `}

  .header-wrap {
    width: 100%;
  }

  .main-wrap {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    flex: 1;
    /* transition: all 0.2s ease; */
    background-color: var(--bg-gray-1);
    z-index: 110;

    .main-contents {
      position: relative;
      transition: all 0.2s ease;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  }
`;

export const AppLayout = () => {
  const { isSubTab, isHeader } = useLayoutStore();
  const { isFullScreen } = useTableDataStore();
  const { loadingCount } = useLoadingStore();

  const [isLoadingOverlay, setIsLoadingOverlay] = useState(false);

  const height = useMemo(() => {
    let excludeHeight = 0;
    if (isHeader && !isFullScreen) excludeHeight += 56;
    if (isSubTab) excludeHeight += 37;

    return `calc(100% - ${excludeHeight}px)`;
  }, [isHeader, isFullScreen, isSubTab]);

  useEffect(() => {
    if (window.location.hash.includes('/project') || window.location.hash.includes('/flows')) {
      setIsLoadingOverlay(false);
    } else {
      setIsLoadingOverlay(loadingCount > 0);
    }
  }, [loadingCount]);

  return (
    <StyledLayout $isLoadingOverlay={isLoadingOverlay}>
      <div className="header-wrap">{isHeader && <NavigationBar />}</div>
      <div className="main-wrap" style={{ height }}>
        <div className="main-contents">
          <Outlet />
        </div>
      </div>
    </StyledLayout>
  );
};
